module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "text-black"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', [_c('span', {
      staticClass: "name font-red"
    }, [_vm._v(_vm._s(item.content) + " ")])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15e98090","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Creditos.vue
// module id = 947
// module chunks = 1